import React, { useState, useEffect } from "react";
import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import axios from "axios";
import { useLocation } from "react-router-dom";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";

const SingleBlog = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[2]; // blog id from URL

  const [data, setData] = useState(false);
  const [editMode, setEditMode] = useState(false);

  // Blog fields
  const [editedTitle, setEditedTitle] = useState("");
  const [editedSlug, setEditedSlug] = useState("");
  const [editedContent, setEditedContent] = useState("");
  const [editedAuthor, setEditedAuthor] = useState("");
  const [editedImageUrl, setEditedImageUrl] = useState("");
  const [editedSeoKeywords, setEditedSeoKeywords] = useState("");
  const [editedSeoDescription, setEditedSeoDescription] = useState("");
  const [uploadError, setUploadError] = useState("");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.mecdistanceeducation.com/api/blogs/${id}`
      );
      setData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleEditClick = () => {
    setEditMode(true);
    setEditedTitle(data.title);
    setEditedSlug(data.slug);
    setEditedContent(data.content);
    setEditedAuthor(data.author);
    setEditedImageUrl(data.imageUrl || "");
    setEditedSeoKeywords(data.seoKeywords?.join(", ") || "");
    setEditedSeoDescription(data.seoDescription || "");
  };

  // Handle image file upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      setUploadError("Only JPG, JPEG, PNG files are allowed!");
      return;
    }

    setUploadError("");

    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await axios.post(
        "https://api.mecdistanceeducation.com/api/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setEditedImageUrl(res.data.imageUrl); // Update imageUrl automatically
    } catch (err) {
      console.log(err);
      setUploadError("Image upload failed. Try again!");
    }
  };

  const handleSaveChanges = async () => {
    try {
      const updatedBlog = {
        title: editedTitle,
        slug: editedSlug,
        content: editedContent,
        author: editedAuthor,
        imageUrl: editedImageUrl,
        seoKeywords: editedSeoKeywords
          .split(",")
          .map((k) => k.trim())
          .filter(Boolean),
        seoDescription: editedSeoDescription,
      };

      const token = localStorage.getItem("access_token");

      const response = await axios.put(
        `https://api.mecdistanceeducation.com/api/blogs/${data._id}`,
        updatedBlog,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Updated blog:", response.data);

      setEditMode(false);
      fetchData();
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="editButton" onClick={handleEditClick}>
              Edit
            </div>
            <div className="item">
              <div className={`details ${editMode ? "editMode" : ""}`}>
                {/* Blog Image */}
                <div className="detailItem">
                  <span className="itemKey">Image:</span>
                  {editMode ? (
                    <>
                      <label htmlFor="fileUpload" className="fileLabel">
                        Upload Image <DriveFolderUploadOutlinedIcon className="icon" />
                      </label>
                      <input
                        type="file"
                        id="fileUpload"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      {editedImageUrl && (
                        <img
                          src={editedImageUrl}
                          alt="Blog"
                          className="itemImage"
                          style={{ width: "50%", marginTop: "10px" }}
                        />
                      )}
                      {uploadError && (
                        <p className="error">{uploadError}</p>
                      )}
                    </>
                  ) : (
                    data.imageUrl && (
                      <img
                        src={data.imageUrl}
                        alt="Blog"
                        className="itemImage"
                        style={{ width: "50%" }}
                      />
                    )
                  )}
                </div>

                {/* Title */}
                <div className="detailItem">
                  <span className="itemKey">Title:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedTitle}
                      onChange={(e) => setEditedTitle(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.title}</span>
                  )}
                </div>

                {/* Slug */}
                <div className="detailItem">
                  <span className="itemKey">Slug:</span>
                  {editMode ? (
                    <input
                      className="editInput"
                      type="text"
                      value={editedSlug}
                      onChange={(e) => setEditedSlug(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.slug}</span>
                  )}
                </div>

           

                {/* Content */}
                <div className="detailItem">
                  <span className="itemKey">Content:</span>
                  {editMode ? (
                    <textarea
                      rows="10"
                      className="editInput"
                      value={editedContent}
                      onChange={(e) => setEditedContent(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.content}</span>
                  )}
                </div>

                {/* Other fields */}
                <div className="detailItem">
                  <span className="itemKey">Author:</span>
                  {editMode ? (
                    <input
                      type="text"
                      value={editedAuthor}
                      className="editInput"
                      onChange={(e) => setEditedAuthor(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.author}</span>
                  )}
                </div>

              
           
                <div className="detailItem">
                  <span className="itemKey">SEO Keywords:</span>
                  {editMode ? (
                    <input
                      type="text"
                      value={editedSeoKeywords}
                      className="editInput"
                      onChange={(e) => setEditedSeoKeywords(e.target.value)}
                      placeholder="Comma-separated"
                    />
                  ) : (
                    <span className="itemValue">{data.seoKeywords?.join(", ")}</span>
                  )}
                </div>

                <div className="detailItem">
                  <span className="itemKey">SEO Description:</span>
                  {editMode ? (
                    <textarea
                      rows="3"
                      value={editedSeoDescription}
                      className="editInput"
                      onChange={(e) => setEditedSeoDescription(e.target.value)}
                    />
                  ) : (
                    <span className="itemValue">{data.seoDescription}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {editMode && (
            <button className="saveBtn" onClick={handleSaveChanges}>
              Save Changes
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleBlog;
